import {
    PUT_URPAYCONFIG_FAILED,
    PUT_URPAYCONFIG_LOADING,
    PUT_URPAYCONFIG_SUCCESS,
} from "../types";

const initialState = {
    loading: false,
    error: null,
    status: null,
};

export const updateurpayConfigReducer = (
    state = initialState,
    action: { type: any; loading: any; payload: any; status: any; error: any }
) => {

   

    switch (action.type) {
        case PUT_URPAYCONFIG_LOADING:
            return {
                ...state,
                loading: true,
            };
        case PUT_URPAYCONFIG_SUCCESS:
            return {
                ...state,
                loading: false,
                MerchantPayment: action.payload,
                status: action.status,
                error: null,
            };
        case PUT_URPAYCONFIG_FAILED:
            return {
                ...state,
                loading: false,
                status: action.status,
                error: action.error,
            };
       
        default:
            return state;
    }
};




